import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_DD_MMM } from '@/helpers/common';
import { prettyDate } from '@scramble/utils';
import { APP_LINKS } from '@/helpers/links';
import { EMPTY_DASH } from '@/helpers/constants';
import { useGetDashboardPaymentInfo } from '@/query/queries/cash/useGetDashboardPaymentInfo';
import IconCalendar from './calendar.svg';
import s from './index.module.scss';

export const DashPaymentInfo = () => {
  const { data: payment } = useGetDashboardPaymentInfo();
  const { t } = useTranslation('dashboard');

  const hasRefin = !!payment?.next_payment_refinanced;

  return (
    <div className={classnames(s.wrapper, hasRefin && 'refin')}>
      <div className={s.row}>
        <div className={s.date}>
          <div className={s.date_value}>
            <img src={IconCalendar} alt="icon" width={16} height={16} />
            <span className="f-body-md f-500">
              {payment?.next_payment_date
                ? prettyDate(payment.next_payment_date, DATE_FORMAT_DD_MMM).replace('.', '')
                : EMPTY_DASH}
            </span>
          </div>
          <div className={classnames(s.date_label, 'f-label')}>
            {t('dash_payment_info.next_repayment')}
          </div>
        </div>
        <MyLink className={classnames(s.add, hasRefin && 'refin')} href={APP_LINKS.addFunds}>
          {t('dash_payment_info.add_funds')}
        </MyLink>
      </div>
      <div>
        <div className={s.pay}>
          <div className="f-label">{t('dash_payment_info.amount_to_pay')}</div>
          <div className="f-h2 f-500">
            {payment ? prettyFloatMoney(payment.next_payment_amount) : EMPTY_DASH}
          </div>
        </div>

        {hasRefin && (
          <div className={s.refin}>
            <div className={s.refin_row}>
              <div className="f-label">{t('dash_payment_info.total_payment')}</div>
              <div className={s.refin_value}>{prettyFloatMoney(payment.next_payment_total)}</div>
            </div>
            <div className={s.refin_row}>
              <div className="f-label">{t('dash_payment_info.refinanced')}</div>
              <div className={s.refin_value}>
                {prettyFloatMoney(payment.next_payment_refinanced)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
